import Call from '../../Call.v2';

const Percentage = {
    get() {
        return Call(`dating/percentage`);
    },

    save(percentage) {
        return Call(`dating/percentage`, 'POST', { percentage });
    },
};

export default Percentage;


// WEBPACK FOOTER //
// ./src/services/API/components/Dating/Percentage.js